import {
  RelatorioPrestacaoContasForm,
  RelatorioPrestacaoContasItem,
  TipoItemRelatorioPrestacaoContas,
} from "core/features/relatorios/prestacao-contas/typings";
import { RelatorioIdEnum } from "core/features/relatorios/typings";
import { Control, UseFormSetValue } from "react-hook-form";
import FiltrosAdicionaisDemonstrativoReceitaDespesa from "./FiltrosAdicionaisRelatorios/DemonstrativoReceitaDespesa";
import FiltrosAdicionaisInadimplentes from "./FiltrosAdicionaisRelatorios/Inadimplentes";
import FiltrosAdicionaisContasETotalDespesas from "./FiltrosAdicionaisRelatorios/ContasETotalDespesas";
import FiltrosAdicionaisMovimentacaoFinanceira from "./FiltrosAdicionaisRelatorios/MovimentacaoFinanceira";
import FiltrosAdicionaisBalancoFinanceiro from "./FiltrosAdicionaisRelatorios/BalancoFinanceiro";

export interface FiltrosAdicionaisProps {
  index: number;
  item: Partial<RelatorioPrestacaoContasItem>;
  control: Control<RelatorioPrestacaoContasForm, any>;
  setValue: UseFormSetValue<RelatorioPrestacaoContasForm>;
}

function FiltrosAdicionais(props: FiltrosAdicionaisProps) {
  const isCapa = props.item.tipoItem === TipoItemRelatorioPrestacaoContas.Capa;

  if (isCapa) {
    return null;
  }

  switch (props.item.relatorioId) {
    case RelatorioIdEnum.Demonstrativo:
    case RelatorioIdEnum.DemonstrativoAnual:
      return <FiltrosAdicionaisDemonstrativoReceitaDespesa {...props} />;
    case RelatorioIdEnum.Receitas:
    case RelatorioIdEnum.TotalDeDespesas:
    case RelatorioIdEnum.ReceitasComComposicao:
    case RelatorioIdEnum.ComposicaoReceitasHorizontal:
    case RelatorioIdEnum.DespesasComComposicao:
      return (
        <FiltrosAdicionaisContasETotalDespesas
          {...props}
          includeTags={
            ![RelatorioIdEnum.ComposicaoReceitasHorizontal].includes(
              props.item.relatorioId
            )
          }
          includeFavorecido={
            props.item.relatorioId === RelatorioIdEnum.TotalDeDespesas
          }
        />
      );
    case RelatorioIdEnum.Inadimplentes:
      return <FiltrosAdicionaisInadimplentes {...props} />;
    case RelatorioIdEnum.MovimentacaoFinanceira:
      return <FiltrosAdicionaisMovimentacaoFinanceira {...props} />;
    case RelatorioIdEnum.BalancoFinanceiro:
      return <FiltrosAdicionaisBalancoFinanceiro {...props} />;
  }

  return null;
}

export default FiltrosAdicionais;
